import { render, staticRenderFns } from "./saveCluePriceDialog.vue?vue&type=template&id=9f56e94a"
import script from "./saveCluePriceDialog.vue?vue&type=script&lang=js"
export * from "./saveCluePriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports